// extracted by mini-css-extract-plugin
export default {"flxflow":"currency_flxflow__TPYBq","spinAround":"currency_spinAround__JH+HD"};